import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectVar } from "../../store/conf/confSlice.js";
import { titleToKey } from "../../services/utils/helpers.js"

function Heading({ children,as = "h1",id,categoryId,title }) {
  const headingBg = useSelector(selectVar("_BKG_HEDEARCOLOR",null));
  // Mantiene il gradiente ma sovrascrive il colore di base del gradiente
//  const containerClass = `px-4 md:px-6 pt-2 pb-3 mt-12 first:mt-6 mb-4 sm:mb-6 text-stone-50 bg-heading-gradient w-full md:w-[70%] rounded-md uppercase col-span-full`;
 const containerClass = `px-4 md:px-6 pt-2 pb-3 mt-12 first:mt-6 mb-4 sm:mb-6 text-stone-50 w-full md:w-[70%] rounded-md uppercase col-span-full`;
  const containerStyle = headingBg ? ({ "--color-red--950": headingBg }) : undefined;
    const normalizedTitle = typeof children === "string" ? children.replace(/^_+/, "") : children;
    console.log("Heading children:", children, "normalizedTitle:", normalizedTitle);
  let element;
  if (categoryId) {
    return (
      <div
        id={id}
        className={containerClass}
        style={containerStyle}
      >
        <h1 className="font-montserrat font-bold text-4xl leading-[1.2] max-md:pt-0.5 md:text-5xl md:leading-[1.1] my-0 md:mt-[0.3rem] md:mb-[0.4rem]"
        style={{
            textShadow: "0 0 10px #d20006, 0 0 20px #d20006, 0 0 40px #ff0000"
          }} 
        >
          {typeof children === "string" ? (
            <Link
              to={`/playlist/all/${categoryId}/${title}`}
              className="hover:underline text-inherit"
              state={{ title: children }}
            >
              {normalizedTitle.toUpperCase()}
            </Link>
          ) : (
            normalizedTitle
          )}
        </h1>
      </div>
    );
  }
  switch (as) {
    case "h1":
    case "h1":
      element = (
        <h1 className="font-montserrat font-bold text-4xl leading-[1.2] max-md:pt-0.5 md:text-5xl md:leading-[1.1] my-0 md:mt-[0.3rem] md:mb-[0.4rem]"
          style={{
            textShadow: "0 0 10px #d20006, 0 0 20px #d20006, 0 0 40px #ff0000"
          }}        >
          {typeof children === "string" ? (
            <Link
              to={`/videos/all/${titleToKey(children)}`}
              className="hover:underline text-inherit"
              state={{ title: children }}
            >
              {normalizedTitle.toUpperCase()}
            </Link>
          ) : (
            normalizedTitle
          )}
        </h1>
      );
      break;
    case "h2":
      element = (
        <h2 className="font-montserrat font-bold text-[2rem] md:text-[2.5rem] m-0">{normalizedTitle}</h2>
      );
      break;
    case "h3":
      element = (
        <h3 className="font-montserrat font-bold text-[1.8rem] md:text-[2.2rem] m-0">{normalizedTitle}</h3>
      );
      break;
    default:
      element = <h1>{normalizedTitle}</h1>;
  }

  return (
    <div
      id={id}
      className={containerClass}
      style={containerStyle}
    >
      {element}
    </div>
  );
}

export default Heading;
